import React from 'react';


// import backIcon from '../../../../icons/back.svg';
// import backIcon from '../../../../icons/backMediumLarge.svg';


import classes from './SideDrawerCloseButton.css';




const sideDrawerCloseButton = props => {
    return (
        <div className={classes.SideDrawerCloseButton} onClick={props.clicked}>
            <img src={props.icon} alt="Error 404"/>
        </div>
    )
}

export default sideDrawerCloseButton;


// WEBPACK FOOTER //
// ./src/components/UI/Buttons/SideDrawerCloseButton/SideDrawerCloseButton.js